export class ListItem{
  id: Number;
	itemName: string;
	category: string;
}
export class MyException {
	status : number;
	body : any;
	constructor(status : number, body : any) {
		this.status = status;
		this.body = body;
	}
}


// WEBPACK FOOTER //
// ./client/app/global/multi-select-dropdown/multiselect.model.ts